import React from "react";
import { motion } from "framer-motion";
import { treatments } from "../Data";

const containerVariants = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.15,
      delayChildren: 0.2,
    },
  },
};

const fadeUp = {
  hidden: {
    opacity: 0,
    y: 40,
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 1.1,
      ease: "easeOut",
    },
  },
};

const cardVariant = {
  hidden: {
    opacity: 0,
    y: 50,
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 1,
      ease: "easeOut",
    },
  },
};

const iconVariant = {
  hidden: {
    opacity: 0,
    scale: 0.8,
  },
  visible: {
    opacity: 1,
    scale: 1,
    transition: {
      duration: 1.2,
      ease: "easeOut",
    },
  },
};

const TreatmentGrid = ({heading, basePath = "/treatments"}) => {
  return (
    <section className="treatments-section">
      <div className="container">
        <motion.p
          className="section-subheading"
          initial="hidden"
          whileInView="visible"
          viewport={{
            once: true,
            amount: 0.2,
          }}
          variants={fadeUp}
        >
          Our Specialized Healing Services
        </motion.p>

        <motion.h2
          className="section-heading"
          initial="hidden"
          whileInView="visible"
          viewport={{
            once: true,
            amount: 0.2,
          }}
          variants={fadeUp}
        >
         { heading || "Authentic Ayurvedic Treatments in Kutch, Gujarat" }
        </motion.h2> 

        <motion.div
          className="treatments-grid"
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{
            once: true,
            amount: 0.15,
          }}
        >
          {treatments.map((item, i) => (
            <motion.div
              className="treatment-card"
              key={i}
              variants={cardVariant}
              whileHover={{
                y: -8,
              }}
              transition={{
                duration: 0.4,
              }}
            >
              <motion.div
                className="treatment-icon-wrapper"
                variants={iconVariant}
              >
                <img
                  src={item.icon}
                  alt={`${item.title} | Dr. Jigar Gor's Ayurveda`}
                />
              </motion.div>

              <h3 className="card-heading">
                {item.title}
              </h3>

              <motion.a
                href={`${basePath}/${item.slug}`}
                whileHover={{
                  y: -3,
                }}
                transition={{
                  duration: 0.3,
                }}
              >
                Know More
              </motion.a>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default TreatmentGrid;